<div id="dialog-photo-example-container">
  <div id="left-block">
    <div id="photo-container">
      <div id="photo"></div>
    </div>
    <p id="example-text" class="paragraph-03-regular grey-800">
      Utilizar fotografía en tamaño 600px x 600 px con <br />
      un espacio en blanco superior de 40 px.
    </p>
  </div>
  <div id="right-block">
    <div class="item-card">
      <p class="subheading-01-semi-bold grey-800 title">
        Ejemplo: perfil del agente
      </p>
      <div id="small-card">
        <div id="round-photo-container">
          <div class="photo-round"></div>
        </div>
        <p class="caption-02-bold grey-900">Nombre Agente</p>
      </div>
    </div>
    <div class="item-card">
      <p class="subheading-01-semi-bold grey-800 title">
        Ejemplo: tarjeta de contacto
      </p>
      <div id="big-card">
        <div id="top">
          <div id="photo-round-small-container">
            <div class="photo-round"></div>
          </div>
          <div id="data-agent-container">
            <p class="caption-02-regular grey-800">CONTACTO</p>
            <p class="caption-02-bold grey-900">Nombre Agente</p>
            <p class="caption-02-regular grey-800">RE/MAX Nombre</p>
          </div>
        </div>
        <div id="bottom">
          <div class="row">
            <div class="icon-container">
              <div id="wsp" class="icon-item"></div>
            </div>
            <p class="caption-02-regular grey-800">+54 9(11)49009499</p>
          </div>
          <div class="row">
            <div class="icon-container">
              <div id="mail" class="icon-item"></div>
            </div>
            <p class="caption-02-regular grey-800">agente@remax.com.ar</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
